import AdSlot from "@/components/yts/AdSlot";
import { useLang } from "@/lib/i18n";

/**
 * The room a band adds above itself.
 *
 * A row of cards already leaves about 18px under its last card — the card's own
 * bottom padding and the rail's — so what a band adds on top is the page's row
 * step (see HomeSections) less that, plus the air that keeps a paid placement
 * reading as a deliberate break rather than another card in the row.
 */
export const BAND_TOP = "pt-6 sm:pt-11";

/**
 * The step a band leaves under itself on pages with no rows to bring it: the
 * same distance a band has above it.
 */
export const BAND_STEP = "mt-6 sm:mt-11";

/**
 * A sponsor band sitting between rows of content.
 *
 * Every band on the site is spaced by this component, so each one sits the same
 * distance from the row above it and the row below, and lines up with the rows'
 * own column. `bare` drops that column for pages whose container already
 * carries it.
 *
 * A band is one placement, disclosed and framed: a hairline and a small
 * letterspaced mark on either side of it. That frame is what keeps a page from
 * reading as one ad after another — the space is signed, and then it is quiet.
 */
export default function AdBand({ placement, bare = false, slot, className = "" }) {
  const { lang } = useLang();
  const column = bare ? "" : "px-4 sm:px-6 max-w-[1180px] mx-auto";

  return (
    <div className={`${column} ${BAND_TOP} ${className}`}>
      <div className="mb-2.5 flex items-center gap-3" aria-hidden="true">
        <span className="h-px flex-1 bg-[#171717]/10 dark:bg-white/15" />
        <span className="shrink-0 font-mono text-[8.5px] font-bold uppercase tracking-[0.24em] text-[#8a857b] dark:text-white/45">
          {lang === "es" ? "Patrocinado" : "Sponsored"}
        </span>
        <span className="h-px flex-1 bg-[#171717]/10 dark:bg-white/15" />
      </div>
      <AdSlot placement={placement} slot={slot} />
    </div>
  );
}